module.exports = __webpack_public_path__ + "img/page-069.e835a629.jpg";